import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import placeholder from "~/assets/placeholder-image.svg";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventInvitation = ({match, event, onChange, ...props}) => {

    const [form, setForm] = useState({
        invitation_copy: event.invitation_copy,
        translations: event.translations
    });

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/invitation', form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    useEffect(() => {
        setForm({
            invitation_copy: event.invitation_copy,
            translations: event.translations
        })
    }, [event])

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <h3>Invitation Page</h3>

                    {message && (
                        <div className="alert alert-success" role="alert">
                            {message}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving event!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label className="d-block">Invitation Copy</label>
                        <small className="d-block mb-2">This copy will be displayed on the invitation page, along with the
                            guest’s package details.</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                            <textarea
                                onChange={handleChange}
                                value={form.invitation_copy}
                                rows={12}
                                name="invitation_copy"
                                className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="invitation_copy"/>
                    </div>
                    <div className="form-group">
                        <label className="d-block">Invitation Image</label>

                        <img className="img-thumbnail mb-2 d-block"
                             src={event.invitation_image.download_url || placeholder}/>

                        <AdminImageUploader
                            image={event.invitation_image}
                            onChanged={onChange}
                            className="text-primary cursor-pointer d-block">Edit Invitation Image
                            Image</AdminImageUploader>
                    </div>
                </div>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Save
            </button>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventInvitation);
